import type { MutationFunction } from '@tanstack/react-query';

import buildRequest, { IBuildRequestConfig, ISearchParams } from './buildRequest';
import executeRequest, { IExecuteRequestConfig } from './executeRequest';

export type IMutationFnFactoryConfig = Omit<IBuildRequestConfig, 'path' | 'body' | 'method'> & {
  method?: Exclude<IBuildRequestConfig['method'], 'GET'>;
} & IExecuteRequestConfig;

export default function mutationFnFactory<TData = Record<string, unknown>, TVariables = Record<string, unknown>>(
  path: IBuildRequestConfig<ISearchParams, TVariables>['path'],
  {
    host,
    searchParams,
    method = 'POST',
    contents,
    accepts,
    headers,
    errorType,
    responseType,
  }: IMutationFnFactoryConfig = {} as IMutationFnFactoryConfig,
): MutationFunction<TData, TVariables> {
  return async function mutationFn(body: TVariables) {
    return executeRequest(
      buildRequest({
        host,
        path,
        headers,
        body,
        method,
        searchParams,
        contents,
        accepts,
      }),
      {
        errorType,
        responseType,
      },
    );
  };
}
